module.exports = __webpack_public_path__ + "img/pi-1-3-2.d554a1c8.jpg";